module.exports = __webpack_public_path__ + "img/Glowkit-StateSettings.92473990.jpg";